var createHeadingSettings = function createHeadingSettings() {
  return {
    title: {
      content: ''
    },
    subtitle: {
      content: ''
    }
  };
};

export default createHeadingSettings;